// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__KUHXc","top":"Sidebar_top__lz6Ya","logo":"Sidebar_logo__gH0am","bottom":"Sidebar_bottom__0HC6z"};